import React from 'react';
import DraggableDialog from '@components-clean/core/draggable-dialog';
import { TextArea } from '@components-clean/core/text-area';
import { useTranslation } from '@hooks/index';

const WIDTH = 650;
const HEIGHT = 400;

type Props = {
    name?: string | null;
    description?: string | null;
    closeFn: () => void;
};

const ReviewPlanDescriptionDialog = ({ name, description, closeFn }: Props) => {
    const { t } = useTranslation();
    const title = t('sm:monitoringToolkit.activeReviewTab.tabs.reviewPlan.reviewPlan.descriptionDialog.title', {
        name,
    });
    return (
        <DraggableDialog
            dataTestId="review-plan-description-dialog"
            title={title}
            primaryBtnLabel={t('close')}
            hideTitleCloseButton
            width={WIDTH}
            height={HEIGHT}
            onSubmit={closeFn}
        >
            <TextArea
                data-testid="review-plan-description-textarea"
                maxLength={3000}
                style={{ height: HEIGHT - 114, overflowY: 'auto' }}
                value={description ?? ''}
                readOnly
            />
        </DraggableDialog>
    );
};

export default ReviewPlanDescriptionDialog;
